<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row mb-4">
              <div class="col-md-6">
                <table class="table table-sm table-borderless">
                  <tbody>
                    <tr>
                      <th style="width:40%">No. Pembelian</th>
                      <td>{{ data.pmb_no || '-' }}</td>
                    </tr>
                    <tr>
                      <th>Tanggal</th>
                      <td>{{ data.pmb_date || '-' }}</td>
                    </tr>
                    <tr>
                      <th>Supplier</th>
                      <td>{{ data.pmb_supplier_name || '-' }}</td>
                    </tr>
                    <tr>
                      <th>Catatan</th>
                      <td>{{ data.pmb_notes || '-' }}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        <span class="badge" :class="data.pmb_status == 1 ? 'badge-success' : 'badge-secondary'">
                          {{ data.pmb_status == 1 ? 'Selesai' : 'Draft' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-6 text-md-right">
                <h5 class="text-muted">Total Pembelian</h5>
                <h3 class="font-weight-bold text-primary">Rp {{ numberFormat(data.pmb_total) }}</h3>
                <div class="mt-3">
                  <router-link
                    :to="{ name: table_module + '_edit', params: { uuid: uuid } }"
                    class="btn btn-warning btn-sm mr-2"
                  >
                    <i class="mdi mdi-pencil mr-1"></i>Edit
                  </router-link>
                  <router-link :to="{ name: table_module }" class="btn btn-secondary btn-sm">
                    <i class="mdi mdi-arrow-left mr-1"></i>Kembali
                  </router-link>
                </div>
              </div>
            </div>

            <hr />

            <h5 class="font-size-15 mb-3">Detail Produk</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Produk</th>
                    <th class="text-center">Qty</th>
                    <th class="text-right">Harga Beli</th>
                    <th class="text-right">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!data.items || data.items.length === 0">
                    <td colspan="5" class="text-center text-muted py-4">Tidak ada item</td>
                  </tr>
                  <tr v-for="(item, index) in data.items" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <strong>{{ item.prd_name }}</strong>
                      <div v-if="item.prd_code" class="text-muted small">{{ item.prd_code }}</div>
                    </td>
                    <td class="text-center">{{ item.pmbd_qty }}</td>
                    <td class="text-right">Rp {{ numberFormat(item.pmbd_price) }}</td>
                    <td class="text-right">Rp {{ numberFormat(item.pmbd_subtotal) }}</td>
                  </tr>
                </tbody>
                <tfoot v-if="data.items && data.items.length > 0">
                  <tr>
                    <th colspan="4" class="text-right">Total</th>
                    <th class="text-right">Rp {{ numberFormat(data.pmb_total) }}</th>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      module: "Pembelian Produk",
      table_module: "pembelian_produk",
      uuid: this.$route.params.uuid,
      data: {},
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios.get("/" + this.table_module + "/detail/" + this.uuid).then((response) => {
        this.data = response.data.data;
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        if (error.response) {
          this.$toast.error("Data tidak ditemukan");
          this.$router.push({ name: this.table_module });
        }
      });
    },
    numberFormat(value) {
      return this.$root.numberWithCommas(value || 0);
    },
  },
};
</script>
